import React, { useState } from 'react';
import { useNavigationCssClasses } from '../../hooks';
import { UserMenuContainer } from '../../../../shared/components/UserMenu';
import { NavLogo } from '../NavLogo/NavLogo';
import { NavItem } from '../NavItem/NavItem';
import { NavExpandButton } from '../NavExpandButton/NavExpandButton';
import './SideBar.scss';
export const SideBar = ({ userId, navigationItems, collapsed, isHidden = false, onCollapsedChanged, customLogo, collapsedCustomLogo, productPrefix, onThemeChange, selectedTheme, selectedContext, onContextChange, customUserMenuItems, overrideUserMenuItems = false, }) => {
    const [innerCollapsed, setInnerCollapsed] = useState(false);
    const innerHandler = (value) => setInnerCollapsed(value);
    const isCollapsed = collapsed !== undefined ? collapsed : innerCollapsed;
    const collapsedHandler = onCollapsedChanged !== undefined ? onCollapsedChanged : innerHandler;
    const { navCss, navButtonsCss, navListCss, navLogoCss } = useNavigationCssClasses({
        collapsed: isCollapsed,
    });
    if (isHidden)
        return React.createElement(React.Fragment, null);
    return (React.createElement("nav", { className: navCss },
        React.createElement("div", { className: navLogoCss },
            React.createElement(NavLogo, { customLogo: customLogo, customCollapsedLogo: collapsedCustomLogo, isCollapsed: isCollapsed })),
        navigationItems.length > 0 ? (React.createElement("ul", { className: navListCss }, navigationItems.map((nav) => (React.createElement("li", { key: `${nav.headerText}_${nav.path}` },
            React.createElement(NavItem, { item: nav, collapsed: isCollapsed })))))) : null,
        React.createElement("div", { className: navButtonsCss },
            React.createElement(UserMenuContainer, { userId: userId, productPrefix: productPrefix, onThemeChange: onThemeChange, selectedTheme: selectedTheme, selectedContext: selectedContext, onContextChange: onContextChange, customUserMenuItems: customUserMenuItems, overrideUserMenuItems: overrideUserMenuItems }),
            React.createElement(NavExpandButton, { collapsed: isCollapsed, onClick: () => collapsedHandler(!isCollapsed) }))));
};
//# sourceMappingURL=SideBar.js.map